import { createFileRoute } from '@tanstack/react-router';
import { LeaveAdmin } from '@/features/leave/LeaveAdmin';
import { LEAVE_TYPE_SECTION_KEYS } from '@/features/leave/leaveTypeSections';

// Admin cataloghi assenze: leave-types / leave-reasons / leave-blackout-periods (CRUD JSON:API).

type LeaveAdminTab = 'types' | 'blackout' | 'closures';
const isTab = (v: unknown): v is LeaveAdminTab => v === 'types' || v === 'blackout' || v === 'closures';

/* `?tab=` sceglie la scheda: la usa il rimando dei periodi di blocco in «Regole di lavoro →
   Assenze», che prima mandava sulla prima scheda e lasciava indovinare che fossero la terza.
   Un valore sconosciuto non passa, e la pagina parte da «Tipi di assenza» — anche `reasons`,
   la scheda delle motivazioni che dal 07-10-2026 sta dentro ogni tipo.

   `?type=<id>&section=<chiave>` apre la scheda di quel tipo su quella sezione: è il link dei
   tipi che fanno eccezione alla regola di approvazione dell'azienda. Una sezione sconosciuta si
   ignora, e la scheda si apre su «Identità». */
export const Route = createFileRoute('/_app/admin/leave-config')({
  validateSearch: (raw: Record<string, unknown>): { tab?: LeaveAdminTab; type?: string; section?: string } => ({
    ...(isTab(raw.tab) ? { tab: raw.tab } : {}),
    ...(typeof raw.type === 'string' && raw.type.trim() ? { type: raw.type.trim() } : {}),
    ...(typeof raw.section === 'string' && LEAVE_TYPE_SECTION_KEYS.includes(raw.section) ? { section: raw.section } : {}),
  }),
  component: LeaveAdmin,
});
